'use client';
import { USER_QUERIES } from '../../infrastructure/user/utils/queries';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UpdateUserRequest, UpdateUserResponse } from '../../infrastructure/user/utils/types';

export const useUserService = () => {
  const useGetCookieUser = () => {
    return useQuery(USER_QUERIES.getCookieUser());
  };

  const useGetUser = ({ enabled = true }: { enabled?: boolean } = {}) => {
    return useQuery({
      ...USER_QUERIES.getUser(),
      enabled,
    });
  };

  return {
    useGetCookieUser,
    useGetUser,
  };
};

export const useUserMutation = () => {
  const useGetCookieUserMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(USER_QUERIES.getCookieUserMutation(queryClient));
  };

  const useUpdateUserMutation = () => {
    const queryClient = useQueryClient();
    return useMutation<UpdateUserResponse, unknown, UpdateUserRequest>(USER_QUERIES.updateUser(queryClient));
  };

  return {
    useGetCookieUserMutation,
    useUpdateUserMutation,
  };
};
